import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { DialogContent, DialogTitle } from "components/common/DialogApi";
import DialogContentText from "@material-ui/core/DialogContentText";
import PropTypes from "prop-types";
import Transition from "./Transition";
import { DialogActions, useMediaQuery } from "@material-ui/core";

const ReuseConfirmationDialog = ({
  handleConfirm,
  handleCancel,
  dialogData,
  open,
}) => {
  const handleClose = function () {
    handleCancel();
  };
  const onConfirm = function () {
    handleConfirm();
  };
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="delete-dialog"
      aria-describedby="delete-dialog-slide-description"
    >
      <DialogTitle id="delete-dialog" onClose={handleClose}>
        {" "}
        {dialogData["title"]}{" "}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-slide-description">
          {dialogData["desc"]}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth={!matches}
          onClick={onConfirm}
          variant="contained"
          color="primary"
        >
          Yes
        </Button>
        <Button fullWidth={!matches} onClick={handleClose} color="secondary">
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};
ReuseConfirmationDialog.propTypes = {
  dialogData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
  }).isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ReuseConfirmationDialog;
